import React from 'react';
import PopupWrapper from './PopupWrapper';
import Menu from './Menu';
import { connect } from 'react-redux';
import { logout } from 'common/actions/authActions';
import {
    getComponentsByUrls,
    getConfigByUrls,
    Paths,
    ViewsMap,
} from 'configs/user-area';
import { withRouter } from 'react-router-dom';
import Headline from 'ui/Headline';
import { history } from 'utils/navigation';

class UserAreaPopup extends React.Component {
    constructor() {
        super();
        this.pathnameToBack = history.location.pathname;
    }

    componentDidMount() {
        this.props.setBackground('rgba(255, 255, 255, 0.7)');
    }

    componentWillUnmount() {
        // if the page was reloaded from the open modal page then navigate home when modal is closed
        const pathnameToBack =
            this.pathnameToBack === history.location.pathname ||
            history.location.pathname.startsWith('/konto')
                ? '/'
                : this.pathnameToBack;
        this.props.history.push(pathnameToBack);
    }

    closeModal = () => {
        this.props.hideModal('USER_AREA_MENU');
    };

    renderContentView = () => {
        const path = history.location.pathname.replace('/', '');
        const components = getComponentsByUrls();
        const ViewMapComponent = components[path];

        if (ViewMapComponent) {
            return <ViewMapComponent {...this.props} desktop={true} />;
        } else {
            const DepositComponent = ViewsMap.indbetaling;

            this.props.history.push('/' + Paths.indbetaling.url);

            return <DepositComponent {...this.props} desktop={true} />;
        }
    };

    renderHeadline = () => {
        const path = history.location.pathname.replace('/', '');
        const userAreaConfig = getConfigByUrls();
        let pathConfig = userAreaConfig[path];

        if (!pathConfig) {
            pathConfig = Paths.deposit;
        }

        return (
            <Headline padding="30px" align="center" black>
                <img
                    src={pathConfig.icon}
                    alt={pathConfig.label}
                    style={{
                        verticalAlign: 'middle',
                        filter:
                            'grayscale(100%) brightness(110%) contrast(0.1)',
                    }}
                    width="30px"
                />{' '}
                {pathConfig.label}
            </Headline>
        );
    };

    logoutHandler = () => {
        this.closeModal();
        this.props.logout();
    };

    render() {
        const pathname = this.props.location.pathname
            ? this.props.location.pathname.replace('/', '')
            : '';

        return (
            <PopupWrapper onClickCloseBth={this.closeModal} pathname={pathname}>
                {{
                    MenuView: (
                        <Menu
                            userData={this.props.auth.user}
                            logoutHandler={this.logoutHandler}
                            hideModal={this.props.hideModal}
                        />
                    ),
                    ContentView: this.renderContentView(),
                    TitleView: this.renderHeadline(),
                }}
            </PopupWrapper>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        logout: () => {
            dispatch(logout());
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(UserAreaPopup));
